import { atom } from 'recoil';

export const paymentMethodChangeAcceptance = atom({
  key: 'paymentMethodChangeAcceptance',
  default: false,
});
